import * as S from './styles';

import 'github-markdown-css';
import { Remarkable } from 'remarkable';
import useChat from './hooks/useChat';
import { IMessage, IProps, ITypeSender } from './types';
import { SyncLoader } from 'react-spinners';
import { useCallback } from 'react';
import Icon from '../Icon';
import Box from '../UI/Box';

import Lottie from 'lottie-react';
import animationData from '../../assets/animations/u60ekp0bPy.json'; // Animation for empty chat
const md = new Remarkable();

const Chat: React.FC<IProps> = ({ promptParam, floating, data }) => {
  const {
    prompt,
    isLoading,
    messages,
    setPrompt,
    handleSubmit,
    onPressEnter,
    extractLink,
  } = useChat({
    promptParam,
    data,
  });

  const placeholder = floating
    ? 'Converse sobre o que você ver na tela.'
    : 'Digite sua pergunta para a Greenfy A.I';

  const renderButtonOrPrompt = useCallback(
    (msg: IMessage) => {
      const link = extractLink(msg.text);
      const textWithoutLink =
        link && link.includes('app.greenfy.agr')
          ? msg.text.replace(link, '').trim()
          : msg.text;

      return (
        <S.WrapperMessageLink>
          {textWithoutLink && (
            <S.MessageText
              dangerouslySetInnerHTML={{ __html: md.render(textWithoutLink) }}
            />
          )}

          {link && (
            <S.LinkToRoute
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              NAVEGAR
            </S.LinkToRoute>
          )}
        </S.WrapperMessageLink>
      );
    },
    [messages]
  );

  const renderProfile = (typeSender: ITypeSender) => {
    if (typeSender === 'greenfy AI') {
      return (
        <S.WrapperProfile typeSender={typeSender} floating={floating}>
          <Icon iconName="AutoAwesomeOutlined" htmlColor="#fff" />

          <S.MessageText white>G</S.MessageText>
        </S.WrapperProfile>
      );
    }
    return (
      <S.WrapperProfile typeSender={typeSender} floating={floating}>
        <S.MessageText white>Eu</S.MessageText>
      </S.WrapperProfile>
    );
  };

  const renderMessageLoading = () => {
    if (isLoading) {
      return (
        <S.WrapperMessage typeSender={'greenfy AI'} floating={floating}>
          <S.WrapperMessageText typeSender={'greenfy AI'}>
            <SyncLoader
              color="#005F47"
              loading
              margin={3}
              size={10}
              speedMultiplier={0.75}
            />
          </S.WrapperMessageText>

          <S.WrapperProfile typeSender={'greenfy AI'} floating={floating}>
            <Icon iconName="AutoAwesomeOutlined" htmlColor="#fff" />
            <S.MessageText white>G</S.MessageText>
          </S.WrapperProfile>
        </S.WrapperMessage>
      );
    }
  };

  const renderButtonLoading = () => {
    if (isLoading) {
      return (
        <Icon iconName="PanToolOutlined" htmlColor="#fff" fontSize="medium" />
      );
    }

    return (
      <Icon
        iconName="SendOutlined"
        htmlColor="#fff"
        fontSize="medium"
        sx={{ cursor: 'pointer' }}
      />
    );
  };

  const renderEmptyMessageFloating = () => {
    if (messages.length === 0 && floating) {
      return (
        <Box
          height={'100%'}
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          gap={10}
        >
          <Lottie animationData={animationData} loop autoplay />
        </Box>
      );
    }
  };
  return (
    <S.Container floating={floating}>
      {renderEmptyMessageFloating()}
      <S.WrapperMenssages>
        {messages.map((msg, index) => (
          <S.WrapperLine key={index} typeSender={msg.sender}>
            <S.WrapperMessage typeSender={msg.sender} floating={floating}>
              <S.WrapperMessageText typeSender={msg.sender} floating={floating}>
                {renderButtonOrPrompt(msg)}
              </S.WrapperMessageText>

              {renderProfile(msg.sender)}
            </S.WrapperMessage>
          </S.WrapperLine>
        ))}
        {renderMessageLoading()}
      </S.WrapperMenssages>

      <S.Form floating={floating}>
        <S.WrapperInput>
          <S.Input
            value={prompt.prompt}
            onChange={(e) => setPrompt({ prompt: e.target.value, data: '' })}
            placeholder={placeholder}
            disabled={isLoading}
            rows={5}
            onKeyDown={onPressEnter}
          />

          <S.WrapperIconSend
            onClick={handleSubmit}
            isLoading={isLoading}
            type="submit"
          >
            {renderButtonLoading()}
          </S.WrapperIconSend>
        </S.WrapperInput>
      </S.Form>
    </S.Container>
  );
};

export default Chat;
